module.exports = __webpack_public_path__ + "img/PropietarioDatos.1b8d114c.svg";